window.STORE_CONFIG = {
  "brand": "GlowStrike",
  "productName": "GlowStrike Neon™ Laser Tag Battle Set",
  "supportEmail": "support@glowstrike.us",
  "logo": "assets/brand/logo.png",
  "currency": "USD",
  "unitName": {
    "one": "set",
    "many": "sets"
  },
  "offers": [
    {
      "id": "duo",
      "title": "Duo Battle",
      "detail": "1 Set · 2 Players",
      "badge": null,
      "image": "assets/media/thumb-2.webp",
      "includes": "GlowStrike Neon™ Laser Tag Duo Set",
      "soldOut": false,
      "units": 1,
      "price": 125.99,
      "compareAt": 140,
      "addons": {}
    },
    {
      "id": "starter",
      "title": "Starter Battle",
      "detail": "1 Set · 4 Players",
      "badge": null,
      "image": "assets/media/thumb-1.webp",
      "includes": null,
      "soldOut": false,
      "units": 1,
      "price": 195.99,
      "compareAt": 210,
      "addons": {}
    },
    {
      "id": "squad",
      "title": "Squad Battle",
      "detail": "1 Set · 8 Players",
      "badge": "SAVE $33.01",
      "image": "assets/media/thumb-1.webp",
      "includes": null,
      "soldOut": false,
      "units": 2,
      "price": 386.99,
      "compareAt": 420,
      "addons": {}
    },
    {
      "id": "ultimate",
      "title": "Ultimate Battle",
      "detail": "1 Set · 12 Players",
      "badge": "SAVE $62.01",
      "image": "assets/media/thumb-1.webp",
      "includes": null,
      "soldOut": false,
      "units": 3,
      "price": 567.99,
      "compareAt": 630,
      "addons": {}
    }
  ],
  "defaultOffer": "starter",
  "addons": [],
  "shipping": {
    "label": "Free tracked shipping",
    "price": 0,
    "eta": "Ships in 1–3 business days",
    "pendingText": "Enter shipping address"
  },
  "gift": null,
  "guarantee": {
    "days": 60
  },
  "subscriptions": {
    "enabled": false
  },
  "checkout": {},
  "policies": {
    "modalsEnabled": true,
    "publish": {
      "shipping": true,
      "returns": true,
      "privacy": true,
      "terms": true,
      "contact": true
    }
  }
};
